import React from "react";
import { Archive } from "lucide-react";
import Button from "../ui/Button";

// Full-screen explanation for a session that was open when its account got
// archived. Deliberately offers no self-serve path back: archiving is an
// internal-admin action and restoring it is too, so the only honest next steps
// are "contact your administrator" and "sign out".
//
// `message` is the server's own wording (User::ARCHIVED_ACCOUNT_MESSAGE, sent
// with the 410) so the login screen and this screen can never drift apart; the
// fallback only covers a 410 that arrives without a body.
export default function ArchivedAccountScreen({ message, onSignOut }) {
  return (
    <div className="flex items-center justify-center min-h-svh p-4">
      <div className="flex flex-col items-center justify-center py-12 px-8 bg-card max-w-lg w-full rounded-2xl border border-border text-center">
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Archive className="h-6 w-6" />
        </div>

        <h1 className="text-xl font-semibold text-foreground mb-3">
          Account archived
        </h1>

        <p className="text-muted-foreground max-w-sm mb-8">
          {message ||
            "This account has been archived. Please contact your administrator."}
        </p>

        <Button variant="secondary" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
